var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1.667h18.462V17H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M10.057.621l-8.94 8.94 5.82 5.82 8.958-8.958.55-5.837-6.388.035z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M12.867 2.057a1.24 1.24 0 0 0-.87 1.533 1.24 1.24 0 0 0 1.52.892 1.24 1.24 0 0 0 .87-1.533 1.24 1.24 0 0 0-1.52-.892z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    strokeLinecap: "square",
    d: "M9.615 4.944L5.77 8.834M11.923 7.278l-3.846 3.889"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.3fc4c12c9d6667569ce35b20762994c5.svg";
export { ForwardRef as ReactComponent };